module.exports = __webpack_public_path__ + "img/test_barcode.98530b6a.svg";